import { Block, Vimeo } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Vimeo,
  React
};